import { all, fork, takeLatest, takeLeading } from 'redux-saga/effects';
import { sliceName } from '../redux/jobApplicationSlice';
import * as Sagas from './saga';

function* watchApplyNow() {
    yield takeLatest(`${sliceName}/applyToJob`, Sagas.applyNowSaga);
}

function* watchFetchActiveJobApplication() {
    yield takeLatest(
        `${sliceName}/fetchJobActiveApplication`,
        Sagas.fetchActiveJobApplication
    );
}

function* watchUpdateJobApplicationStatus() {
    yield takeLatest(
        `${sliceName}/updateJobApplicationStatus`,
        Sagas.updateJobApplicationStatus
    );
}

function* watchFetchJobApplicationsStatistics() {
    yield takeLatest(
        `${sliceName}/fetchJobApplicationsStatistics`,
        Sagas.fetchJobApplicationsStatistics
    );
}

function* watchCreateJobApplicationCommentSaga() {
    yield takeLatest(
        `${sliceName}/createJobApplicationComment`,
        Sagas.createJobApplicationCommentSaga
    );
}

function* watchSendChatMessage() {
    yield takeLatest(`${sliceName}/sendChatMessage`, Sagas.sendChatMessageSaga);
}

function* watchSaveForLater() {
    yield takeLeading(`${sliceName}/saveForLater`, Sagas.saveForLaterSaga);
}

function* watchLoadNextOrPrevCandidate() {
    yield takeLeading(
        `${sliceName}/loadNextOrPrevCandidate`,
        Sagas.loadNextOrPrevCandidateSaga
    );
}

function* watchApplyTag() {
    yield takeLatest(
        `${sliceName}/applyTagToJobApplication`,
        Sagas.applyTagToJobApplicationSaga
    );
}

function* watchDeleteTag() {
    yield takeLatest(
        `${sliceName}/deleteTagFromJobApplication`,
        Sagas.deleteTagFromJobApplicationSaga
    );
}

function* watchUpdateUserRequirementScore() {
    yield takeLatest(
        `${sliceName}/updateUserRequirementScore`,
        Sagas.updateUserRequirementScoreSaga
    );
}

function* watchTransferCandidate() {
    yield takeLatest(
        `${sliceName}/transferCandidate`,
        Sagas.transferCandidateSaga
    );
}

function* watchScheduleInterview() {
    yield takeLatest(
        `${sliceName}/scheduleInterview`,
        Sagas.scheduleInterviewSaga
    );
}

function* watchUpdateCandidateInfo() {
    yield takeLatest(
        `${sliceName}/updateCandidateInfo`,
        Sagas.updateCandidateInfoSaga
    );
}

function* watchBulkRejectApplication() {
    yield takeLatest(
        `${sliceName}/bulkRejectApplication`,
        Sagas.bulkRejectApplicationSaga
    );
}

export function* jobApplicationSagas() {
    yield all([
        fork(watchApplyNow),
        fork(watchFetchActiveJobApplication),
        fork(watchUpdateJobApplicationStatus),
        fork(watchFetchJobApplicationsStatistics),
        fork(watchCreateJobApplicationCommentSaga),
        fork(watchSendChatMessage),
        fork(watchSaveForLater),
        fork(watchLoadNextOrPrevCandidate),
        fork(watchApplyTag),
        fork(watchDeleteTag),
        fork(watchUpdateUserRequirementScore),
        fork(watchTransferCandidate),
        fork(watchScheduleInterview),
        fork(watchUpdateCandidateInfo),
        fork(watchBulkRejectApplication),
    ]);
}
